module.exports = __webpack_public_path__ + "static/media/d2.8e711bd9.jpg";